var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconApple(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 22,
    viewBox: "0 0 19 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 4.95905C12.3218 4.8311 10.9167 5.66738 9.5 5.66738C8.08333 5.66738 6.67773 4.82623 5.25 4.95905C2.41667 5.22467 1 7.79238 1 12.0424C1 15.584 3.83333 20.5424 5.92292 20.5424C8.0125 20.5424 8.22234 19.4799 9.5 19.4799C10.7777 19.4799 10.9871 20.5424 13.0771 20.5424C15.1671 20.5424 18 15.584 18 12.0424C18 7.79238 16.7161 5.22467 13.75 4.95905Z",
    stroke: "#FA124F",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5068 2.97292C11.5771 3.90261 10.4854 4.16824 9.90281 4.24748C9.84955 4.25516 9.79523 4.2506 9.74399 4.23414C9.69275 4.21769 9.64594 4.18977 9.6071 4.15251C9.56827 4.11526 9.53843 4.06964 9.51987 4.01913C9.5013 3.96862 9.49449 3.91454 9.49995 3.861C9.60503 2.86515 10.0527 1.93672 10.7665 1.23441C11.7405 0.26045 12.803 0.0435227 13.3661 0.00146539C13.4187 -0.00333165 13.4717 0.00368368 13.5212 0.0219982C13.5707 0.0403128 13.6155 0.0694633 13.6523 0.107317C13.6891 0.145171 13.7169 0.190771 13.7338 0.240782C13.7507 0.290792 13.7562 0.343948 13.7499 0.396361C13.6388 1.37106 13.2006 2.27932 12.5068 2.97292Z",
    fill: "#3FED50",
    fillOpacity: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.72919 14.8755C8.31599 14.8755 8.79169 13.9241 8.79169 12.7505C8.79169 11.5769 8.31599 10.6255 7.72919 10.6255C7.14238 10.6255 6.66669 11.5769 6.66669 12.7505C6.66669 13.9241 7.14238 14.8755 7.72919 14.8755Z",
    fill: "#979797"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2708 14.8755C11.8576 14.8755 12.3333 13.9241 12.3333 12.7505C12.3333 11.5769 11.8576 10.6255 11.2708 10.6255C10.684 10.6255 10.2083 11.5769 10.2083 12.7505C10.2083 13.9241 10.684 14.8755 11.2708 14.8755Z",
    fill: "#979797"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconApple);
export default __webpack_public_path__ + "static/media/icon-apple.035b14f873027576333fc2fbf77e81f7.svg";
export { ForwardRef as ReactComponent };